<template>
    <tr>
      <!-- title -->
      <td class="text-left ml-5">
        <router-link class="color-default" :to="'/webinar/' + webinar.slug">{{ webinar.title }}</router-link>
      </td>
      <td v-if="webinar.published == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <td v-if="webinar.featured == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <!-- controls [Update, Delete] -->
      <td>
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link class="dropdown-item" :to="'/webinar/edit/' + webinar.slug">Update</router-link>
          <template>
            <a class="dropdown-item" v-if="webinar.published == 0" @click="publishing('publish')">Publish</a>
            <a class="dropdown-item" v-else @click="publishing('unpublish')">Unpublish</a>
          </template>
          <a class="dropdown-item text-danger" @click="deleteWebinar">Delete</a>
        </ul>
      </td>
    </tr>
  </template>
  
  <script>
import webinar from '../../store/modules/webinar';

    export default {
      name: "FAQRow",
      props: ["webinar", "pageNumber"],
      computed: {
        author: function () {
          if (typeof this.webinar.author === "undefined") {
            return "unknown";
          }
          return this.webinar.author.name;
        },
      },
      methods: {
        publishing(action) {
          this.$store
            .dispatch("webinar/publishing", {
              webinar: this.webinar,
              action: action,
            })
            .then((response) => { 
              if(response.data.data.published == 1) {
                this.$toast.success('Webinar published successfully!');
              } else {
                this.$toast.success('Webinar unpublished successfully!');
              }
             
            });
        },
        deleteWebinar() {
          this.$store.dispatch("message/update", {
            title: this.webinar.title,
            body: "Are you sure you want to delete this webinar?",
            class: "danger",
            confirm: true,
          });
  
          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.delete(this.webinar);
            this.$store.dispatch("message/close");
          });
        },
        delete(webinar) {
          this.$store.dispatch("webinar/delete", webinar)
            .then(() => {
              this.$parent.$parent.getWebinars(this.pageNumber,'');
              this.$toast.success('Webinar deleted successfully!');
            })
            .catch((error) => {
              // send error message
              this.$toast.success(error.response.data.message);
            });
        },
      },
    };
  </script>
  <style scoped>
    table tr td:nth-child(1) {
      width: 35% !important;
      padding-left: 40px;
    }
  
    table tr td:nth-child(2) {
      width: 35% !important;
    }
  
    table tr td:nth-child(3) {
      width: 20% !important;
    }
  
    table tr td:nth-child(4) {
      width: 10% !important;
    }
  </style>